export default {
	required: 'Required field',
	confirm: 'Value do not match',
	regExp: 'Please, enter a valid value',
	valid: '',
	min: 'The entered value is short',
	max: 'The entered value is long',
};
